import fetch from 'node-fetch';
import router from '@/router';
import store from '@/store';
import { logout } from './utils.js'

async function makeApiRequest (path, method = 'GET', body = {}, impersonateToken = store.state.impersonateData) {
  const route = router.currentRoute.value;

  const params = {
    method: method,
    headers: { 'content-Type': 'application/json' },
    body: Object.keys(body).length !== 0 ? JSON.stringify(body) : undefined
  };

  let url = path;

  if (store.state.agency) {
    // check if the url already contains params
    url = url.includes('?') ? `${url}&` : `${url}?`;

    url = `${url}agency=${encodeURI(store.state.agency)}`;
  }

  if (impersonateToken) {
    // check if the url already contains params
    url = url.includes('?') ? `${url}&` : `${url}?`;

    url = `${url}impersonateData=${encodeURI(impersonateToken)}`;
  }

  return await fetch(`/espacepersonnel${url}`, params)
    .then(response => response.json())
    .then(response => {
      if (response.loginUrl) {
        // TODO IMPROVE
        let return_url = '/espacepersonnel';

        // vue app runs in /reservation and vue thinks it's /, /?
        return_url += route.path === '/' ? route.fullPath.substring(1) : route.fullPath;

        // this.$cookies.set('return_url', return_url);

        store.commit('setLoading', true);

        window.location.href = response.loginUrl;
        throw (response);
      }

      // On user updates we should not let user update his data if he is anonymised. Nobody will remember this edge case in new mutations that updates user data so this code was implemented in here.
      if (response.code === 'CUSTOMER_ANONYMISED' || response.data?.anonymizeTime) {
        logout()
        return null;
      }

      return response;
    }).catch(err => {
      console.log('[ERROR]', err);
      return err;
    });
}

async function getUser () {
  const user = await makeApiRequest('/api/user', 'GET');
  if (!user.success) {
    return null; // Loading and redirect to SSO
  }

  let contactsData = [];
  if (user.data.contacts) {
    // Remove self user from contact
    contactsData = user.data.contacts.filter(c => c.uuid !== user.data.uuid);
  }
  
  store.commit('setUser', user.data);
  store.commit('setContacts', contactsData);

  return user;
}

async function getOrders (start = 0, limit = 10, status = null, departureStartDate = null) {
  const orders = await makeApiRequest(`/api/orders?start=${start}&limit=${limit}&status=${status}&departureStartDate=${departureStartDate}`, 'GET');
  if (!orders.success) {
    return {
      count: 0,
      items: []
    };
  }
  return orders.data;
}

async function getCodes (start = 0, limit = 10) {
  const codes = await makeApiRequest(`/api/codes?start=${start}&limit=${limit}`, 'GET');
  if (!codes.success) {
    return {
      count: 0,
      items: []
    };
  }
  return codes.data;
}

async function getReferrals (start = 0, limit = 10) {
  const codes = await makeApiRequest(`/api/referrals?start=${start}&limit=${limit}`, 'GET');
  if (!codes.success) {
    return {
      count: 0,
      items: []
    };
  }
  return codes.data;
}

async function getOptions (start = 0, limit = 10) {
  const orders = await makeApiRequest(`/api/options?start=${start}&limit=${limit}`, 'GET');
  if (!orders.success) {
    return {
      count: 0,
      items: []
    };
  }
  return orders.data;
}

async function cancelOption (bookingNumber) {
  const response = await makeApiRequest(`/api/option/cancel?number=${bookingNumber}`, 'GET');
  return response;
}

async function getOrder (bookingNumber) {
  const order = await makeApiRequest(`/api/booking-data?bookingNumber=${bookingNumber}`, 'GET');

  if (!order.success) {
    return {};
  }

  return order.data;
}
async function getBillets (start = 0, limit = 10) {
  const orders = await makeApiRequest(`/api/billets?start=${start}&limit=${limit}`, 'GET');
  if (!orders.success) {
    return {};
  }

  return orders.data;
}

async function updateUser (data) {
  const user = await makeApiRequest('/api/profile', 'PUT', data);

  if (user.success) {
    store.commit('setUser', user.data);
  }

  return user;
}

async function anonymiseUser() {
  const response = await makeApiRequest('/api/anonymise', 'POST', {});

  return response;
}

async function createContact (data) {
  return makeApiRequest('/api/contact', 'POST', { ...data });
}

async function updateContact (data) {
  return makeApiRequest('/api/contact', 'PUT', data);
}

async function deleteContact(contact) {
  return makeApiRequest(`/api/contact/${contact}`, 'DELETE');
}

async function getSessions (startDate, endDate) {
  let url = '/api/sessions';
  const params = [];
  
  if (startDate) {
    params.push(`startDate=${startDate}`);
  }
  if (endDate) {
    params.push(`endDate=${endDate}`);
  }
  
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }
  
  const response = await makeApiRequest(url, 'GET');

  if (response && response.success) {
    return response.data;
  }

  return null;
}

async function getEquipment (startDate, endDate) {
  let url = '/api/equipment';
  const params = [];
  
  if (startDate) {
    params.push(`startDate=${startDate}`);
  }
  if (endDate) {
    params.push(`endDate=${endDate}`);
  }
  
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }
  
  const response = await makeApiRequest(url, 'GET');

  if (response && response.success) {
    return response.data;
  }

  return null;
}


async function updateNewsletters (data) {
  const user = await makeApiRequest('/api/newsletters', 'PUT', data);
  if (!user.success) {
    return null; // Loading and redirect to SSO
  }

  return user;
}

async function getCenters (start = 0, limit = 1000) {
  const centers = await makeApiRequest(`/api/centers?start=${start}&limit=${limit}`, 'GET');
  if (!centers.success) {
    return {};
  }

  return centers.data;
}

async function createWallet (data) {
  const wallet = await makeApiRequest('/api/wallet', 'POST', { ...data });
  if (!wallet.success) {
    return null; // Loading and redirect to SSO
  }

  return wallet;
}

async function getWallets (start = 0, limit = 11) {
  const wallets = await makeApiRequest(`/api/wallets?start=${start}&limit=${limit}`, 'GET');
  if (!wallets.success) {
    return {};
  }

  return wallets.data;
}

async function getWalletsPaymentHistory (wallet_uuid, startDate = null, endDate = null) {
  let url = `/api/wallet-payment-history?uuid=${wallet_uuid}`;

  if (startDate) {
    url += `&startdate=${startDate}${endDate ? `&enddate=${endDate}` : ''}`;
  }

  const walletHistory = await makeApiRequest(url, 'GET');
  if (!walletHistory.success) {
    return {};
  }

  return walletHistory.data;
}

async function shareQRcode (email, wallet_uuid, locale) {
  await makeApiRequest(`/api/share-qrcode?email=${email}&wallet_uuid=${wallet_uuid}&locale=${locale}`, 'GET');
}

async function getPayboxForm (data) {
  const paybox = await makeApiRequest('/api/payment', 'POST', { ...data });

  if (!paybox.success) {
    return {};
  }

  return paybox;
}

async function walletRefund (data) {
  return await makeApiRequest('/api/refund', 'POST', { ...data });
}

async function getSiteConfiguration () {
  const siteConfiguration = await makeApiRequest('/api/siteconfiguration');

  if (!siteConfiguration.success) {
    return {};
  }

  store.commit('setSiteConfiguration', siteConfiguration);

  return siteConfiguration;
}

async function createReferral (data) {
  const referral = await makeApiRequest('/api/referral', 'POST', data);

  return referral;
}

async function isImpersonateMode (impersonateToken) {
  return makeApiRequest('/api/impersonateMode', 'GET', {}, impersonateToken);
}

async function addVisibleOrder (booking, clientReference) {
  return makeApiRequest('/api/addVisibleOrder', 'POST', { booking: booking, clientReference: clientReference });
}

// async function getParticipantsSessionsCount () {
//   const response = await makeApiRequest('/api/sessions-count', 'GET');

//   if (response && response.success) {
//     return response.data.sessionsCount || 0;
//   }

//   // Return 0 on error to hide Planning tab (fail-safe behavior)
//   return 0;
// }

export {
  makeApiRequest,
  getUser,
  getOrder,
  getOrders,
  getCodes,
  getOptions,
  cancelOption,
  getBillets,
  updateUser,
  createContact,
  updateContact,
  updateNewsletters,
  createWallet,
  getCenters,
  getWallets,
  getWalletsPaymentHistory,
  shareQRcode,
  walletRefund,
  getPayboxForm,
  getSiteConfiguration,
  createReferral,
  getReferrals,
  isImpersonateMode,
  addVisibleOrder,
  anonymiseUser,
  getSessions,
  getEquipment,
  deleteContact,
  // getParticipantsSessionsCount
};
